import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';

import { CognitoService } from '../../services/cognito.service';
import { ThemeManagerService } from 'src/app/services/theme-manager.service';

@Component({
  selector: 'app-registration-confirm',
  template: `
<form [formGroup]="confirmForm" class="dashboard-tile mat-elevation-z4">
  <div class="tile-header">
    <div class="tile-header-title">
      Registration Confirmation
    </div>
  </div>
  <div class="tile-content">
    <img mat-card-image class="tile-logo" src="{{_themeManager.getStackedLogo()}}" >
    <div *ngIf="showHint" class="text-primary" style="text-align:center">
      You should receive an email with your confirmation code shortly.
    </div>
    <div class="formFieldList">
      <div *ngIf="confirmForm.errors?.failedConfirmation">
        <mat-error>{{confirmForm.errors.failedConfirmation}}</mat-error>
      </div>
      <mat-form-field>
        <input formControlName="email" matInput placeholder="Email Address" required>
      </mat-form-field>
      <mat-form-field>
        <input formControlName="confirmationCode" matInput placeholder="Confirmation Code" required>
      </mat-form-field>
    </div>
    <div class="tile-footer centered">
      <button mat-raised-button type="submit" color="primary" (click)="onConfirmRegistration()">Confirm</button>
      <button mat-raised-button type="button" color="primary" (click)="onResend()">Resend Code</button>
      <button mat-raised-button type="button" color="primary" (click)="stateChange.emit({state:'LOGIN'})">Return to Login</button>
    </div>
  </div>
</form>
  `,
  styleUrls: ['../auth/auth.layout.scss']
})
export class ConfirmRegistrationComponent implements OnInit {
  @Output() stateChange: EventEmitter<any> = new EventEmitter();
  @Input() email;
  @Input() confirmationCode;

  showHint = false;

  confirmForm = new FormGroup ({
    email: new FormControl('', [Validators.required, Validators.email]),
    confirmationCode: new FormControl('', [Validators.required])
  });

  constructor(private _cognitoService: CognitoService, public _themeManager: ThemeManagerService) { }

  ngOnInit() {
    this.confirmForm.controls.email.setValue(this.email);
    this.confirmForm.controls.confirmationCode.setValue(this.confirmationCode);

    if (this.email && !this.confirmationCode) {
      this.showHint = true;
    }
  }

  onConfirmRegistration() {
    this.showHint = false;
    if (this.confirmForm.valid) {
      this._cognitoService.confirmRegistration(this.confirmForm.value.email, this.confirmForm.value.confirmationCode).then(
        success => {
          this.stateChange.emit({state:'LOGIN'});
        },
        error => {
          this.confirmForm.setErrors({failedConfirmation: error});
        }
      );
    }
  }

  onResend() {
    this.showHint = false;
    this.confirmForm.controls.email.updateValueAndValidity();
    if (this.confirmForm.controls.email.valid) {
      this._cognitoService.resendCode(this.confirmForm.value.email).then(
        success => {
          this.showHint = true;
        },
        error => {
          this.confirmForm.setErrors({failedConfirmation: error});
        }
      );
    }
  }
}